import React from "react";

const Blog2 = () => {
  return (
    <>
      <p className="text-lg leading-relaxed text-gray-700 mb-6">
        Staying connected is critical in today's world, Whether you’re hosting a
        webinar, conducting a business meeting, or connecting with friends and
        family, having a reliable video conferencing tool makes all the
        difference. Konn3ct is an indigenous Nigerian platform designed to make
        video meetings accessible, affordable, and feature-rich for individuals
        and businesses.{" "}
      </p>

      <p className="text-lg leading-relaxed text-gray-700 mb-6">
        In this blog post, we’ll cover everything on how to use Konn3ct—how to
        sign up, host or join meetings, and make the most of its standout
        features.{" "}
      </p>

      <h1 className="text-3xl font-bold mb-8 text-[#1A4699]">
        Konn3ct User Guide
      </h1>

      {/* ---------------------- SECTION 1 ---------------------- */}
      <section className="mb-12">
        <h2 className="text-2xl font-semibold mb-4">
          1. How to Sign Up on Konn3ct
        </h2>

        <h3 className="font-semibold text-lg">Step 1: Visit the Website</h3>
        <p className="mb-4">
          Head over to your preferred browser and type in the URL:{" "}
          <a
            href="https://dashboard.konn3ct.com"
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-600 hover:text-blue-800"
          >
            konn3ct.com
          </a>{" "}
          (spelled as “K-O-N-N-3-C-T.com”). This will take you to the platform’s
          homepage.
        </p>

        <h3 className="font-semibold text-lg">Step 2: Click “Sign Up”</h3>
        <p className="mb-4">
          On the homepage, click the{" "}
          <span className="font-semibold">Sign Up for Free</span> button. You’ll
          be able to choose either a <strong>Personal Account</strong> or a
          <strong> Corporate Account</strong>.
        </p>

        <h3 className="font-semibold text-lg">Step 3: Fill in Your Details</h3>
        <ul className="list-disc ml-6 mb-4">
          <li>Enter your full name, email address, and password.</li>
          <li>Complete the CAPTCHA verification.</li>
          <li>
            Enter a referral code if available (e.g., <strong>552204</strong>).
          </li>
        </ul>
        <p className="mb-4">
          Once done, click <strong>Submit</strong> to create your account.
        </p>

        <h3 className="font-semibold text-lg">Step 4: Verify Your Email</h3>
        <p>
          Check your inbox for a verification email. Click the link to activate
          your account.
        </p>
      </section>

      {/* ---------------------- SECTION 2 ---------------------- */}
      <section className="mb-12">
        <h2 className="text-2xl font-semibold mb-4">
          2. How to Join a Meeting
        </h2>

        <p className="mb-4">
          Joining a Konn3ct meeting is very easy. Here’s how:
        </p>

        <h3 className="font-semibold text-lg">
          Option 1: Using a Meeting Link
        </h3>
        <ul className="list-disc ml-6 mb-4">
          <li>Receive the link from the meeting host.</li>
          <li>Click the link to open the meeting page.</li>
          <li>
            Enter your <strong>name</strong> and <strong>email address</strong>.
          </li>
          <li>
            Enter the <strong>access code</strong> if required, then click
            <strong> Join Meeting</strong>.
          </li>
        </ul>

        <h3 className="font-semibold text-lg">
          Option 2: Using the Meeting Room Name
        </h3>
        <ul className="list-disc ml-6 mb-4">
          <li>
            Go to the Konn3ct homepage and click{" "}
            <strong>Join a Meeting Room</strong>.
          </li>
          <li>Type the room name (e.g., “Theo’s Room”).</li>
          <li>Enter your name and email.</li>
          <li>Enter the access code if required.</li>
        </ul>

        <h3 className="font-semibold text-lg">Once Inside the Meeting:</h3>
        <ul className="list-disc ml-6">
          <li>Mute or unmute using the microphone icon.</li>
          <li>Turn camera on/off using the camera icon.</li>
          <li>Use group or private chat to communicate.</li>
        </ul>
      </section>

      {/* ---------------------- SECTION 3 ---------------------- */}
      <section className="mb-12">
        <h2 className="text-2xl font-semibold mb-4">
          3. How to Host a Meeting
        </h2>

        <h3 className="font-semibold text-lg">
          Step 1: Log in to Your Account
        </h3>
        <p className="mb-4">
          Visit <strong>Konn3ct.com</strong>, click <strong>Login</strong>, and
          enter your email and password.
        </p>

        <h3 className="font-semibold text-lg">Step 2: Create a Meeting Room</h3>
        <ul className="list-disc ml-6 mb-4">
          <li>
            Click <strong>Host a Meeting</strong> on the dashboard.
          </li>
          <li>
            Click the <strong>+</strong> icon to create a room.
          </li>
          <li>Name your meeting room (e.g., “Marketing Sync”).</li>
          <li>
            Click <strong>Create</strong>.
          </li>
        </ul>

        <h3 className="font-semibold text-lg">Step 3: Start the Meeting</h3>
        <p>
          Select your room and click <strong>Start</strong>. Share the meeting
          link or room name with participants.
        </p>
      </section>

      {/* ---------------------- SECTION 4 ---------------------- */}
      <section className="mb-12">
        <h2 className="text-2xl font-semibold mb-4">
          4. Key Features of Konn3ct
        </h2>

        <h3 className="font-semibold text-lg">
          1. Group Chat & Private Messaging
        </h3>
        <p className="mb-4">
          Share messages with all participants or send private messages for
          sensitive discussions.
        </p>

        <h3 className="font-semibold text-lg">2. Document Collaboration</h3>
        <p className="mb-4">
          Work on shared documents in real-time—perfect for brainstorming and
          planning.
        </p>

        <h3 className="font-semibold text-lg">3. Access Control</h3>
        <p className="mb-4">
          Hosts can enable an access code for better security.
        </p>

        <h3 className="font-semibold text-lg">4. Screen Sharing</h3>
        <p className="mb-4">Present slides, demos, or documents easily.</p>

        <h3 className="font-semibold text-lg">5. Breakout Rooms</h3>
        <p className="mb-4">
          Split participants into smaller groups for discussions or activities.
        </p>

        <h3 className="font-semibold text-lg">
          6. Recording Meetings (Pro Only)
        </h3>
        <p className="mb-4">
          Record your sessions for review. Available only for Pro subscribers.
        </p>
      </section>

      {/* ---------------------- SECTION 5 ---------------------- */}
      <section className="mb-12">
        <h2 className="text-2xl font-semibold mb-4">
          5. Pro Tips for a Smooth Konn3ct Experience
        </h2>

        <ul className="list-disc ml-6">
          <li>Use a stable internet connection.</li>
          <li>Test your mic, camera, and speakers before joining meetings.</li>
          <li>Use headphones for clearer audio.</li>
          <li>Explore features like breakout rooms and collaboration tools.</li>
        </ul>
      </section>

      {/* ---------------------- SECTION 6 ---------------------- */}
      <section>
        <h2 className="text-2xl font-semibold mb-4">
          6. Why Konn3ct is the Best Choice for Nigerians
        </h2>

        <p className="mb-4">
          Konn3ct isn’t just another video conferencing app—it’s built with
          Nigerians in mind.
        </p>

        <ul className="list-disc ml-6">
          <li>
            <strong>Affordable & Local:</strong> Pay in Naira without worrying
            about exchange rates.
          </li>
          <li>
            <strong>User-Friendly:</strong> Simple and intuitive interface.
          </li>
          <li>
            <strong>Great Value:</strong> Premium features at an affordable
            cost.
          </li>
        </ul>
      </section>
      <section>
        <h3 className="text-xl font-semibold mt-6 mb-2">Conclusion</h3>
        <p className="text-gray-700 mb-4">
          Konn3ct is the ideal video conferencing solution for individuals,
          businesses, and educational institutions in Nigeria. Whether you’re
          hosting a virtual event or joining a casual catch-up, Konn3ct’s
          affordability, simplicity, and robust features make it the perfect
          choice.
        </p>

        <p className="text-gray-700 font-semibold text-lg mt-4">
          Ready to get started? Visit{" "}
          <a
            href="https://dashboard.konn3ct.com/login"
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-600 underline hover:text-blue-800"
          >
            konn3ct.com
          </a>{" "}
          today,{" "}
          <a
            href="https://dashboard.konn3ct.com/register"
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-600 underline hover:text-blue-800"
          >
            sign up
          </a>{" "}
          for free, and experience seamless video communication !
        </p>

        <p className="text-gray-700 font-medium italic">
          "Sign up now and enjoy your first hour of free meetings. Don’t forget
          to use your referral code for additional benefits!"
        </p>
      </section>
    </>
  );
};

export default Blog2;
